<template>
    <div id="Console">
        <el-row>
            <el-col :span="24" >
                <el-tabs type="border-card">
                    <el-tab-pane label="账户管理">
                        <div>
                            <el-row>
                                <el-col :span="5" :sm="7" :md="8" :lg="18" :xl="16">
                                    <el-button-group>
                                        <el-button type="info" icon="el-icon-refresh" @click="refresh()">刷新</el-button>
                                        <el-button type="info" icon="el-icon-circle-plus" @click="addAccount">添加账户</el-button>
                                        <el-button @click="downLoad2('用户管理')" type="success">下载表格</el-button>
                                        
                                    </el-button-group>
                                </el-col>
                                <el-col :span="6" class="serch-input" style="float:right;">
                                    <el-input placeholder="请输入用户账号" v-model="input5" class="input-with-select" clearable>
                                    </el-input>
                                </el-col>
                            </el-row>
                             <!-- 用户表格 -->
                            <el-row class="userList">
                                <el-col :span="24">
                                    <el-table
                                        v-loading="loading"
                                        element-loading-text="加载中"
                                        :data="tableData3.filter(data => !input5 || data.userId.includes(input5.toUpperCase()))"
                                        height="320"
                                        border
                                        style="width: 100%"
                                    >
                                        <el-table-column
                                            prop="userId"
                                            label="用户账号"
                                            width="120"
                                            header-align="center"
                                        >
                                        </el-table-column>
                                        <el-table-column
                                            prop="name"
                                            label="用户名称"
                                            header-align="center"
                                        >
                                        </el-table-column>
                                        <el-table-column
                                            prop="locationCode"
                                            label="销售地点"
                                            header-align="center"
                                        >
                                        </el-table-column>

                                        <el-table-column
                                            prop="userLevel"
                                            label="用户级别"
                                            width="90"
                                            header-align="center"
                                            :formatter="userFormatter"
                                        >
                                        </el-table-column>
                                        <el-table-column
                                            prop="lastUpdateDate"
                                            label="最后更新日期"
                                            width="160"
                                            header-align="center"
                                        >
                                        </el-table-column>
                                        <el-table-column
                                            prop="lastUpdateUser"
                                            label="最后更新者"
                                            width="100"
                                            header-align="center"
                                        >
                                        </el-table-column>
                                        <el-table-column
                                            prop="operation"
                                            label="操作"
                                            header-align="center"
                                        >
                                            <template slot-scope="scope">
                                                <el-row>
                                                    <el-button-group>
                                                        <el-tooltip class="item" effect="dark" content="重置密码" placement="bottom" >
                                                            <el-button type="info" size="small" plain icon="el-icon-setting" @click.native.prevent="resetPass(scope.$index,scope.row)" class="operateBtn"></el-button>
                                                        </el-tooltip>
                                                        <el-tooltip class="item" effect="dark" content="修改" placement="bottom">
                                                            <el-button type="info" size="small" plain icon="el-icon-edit" @click.native.prevent="revise(scope.$index,scope.row)" class="operateBtn"></el-button>
                                                        </el-tooltip>
                                                        <el-tooltip class="item" effect="dark" content="删除账号" placement="bottom">
                                                            <el-button type="danger" size="small" icon="el-icon-delete"  @click.native.prevent="deleteRow(scope.$index, scope.row)" class="operateBtn"></el-button>
                                                        </el-tooltip>
                                                    </el-button-group>
                                                </el-row>
                                            </template>                                             
                                        </el-table-column>
                                    </el-table>
                                </el-col>
                            </el-row>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </el-col>
        </el-row>
    </div>
</template>
<style lang="less">
    #Console{
        .userList{
            margin: 20px 0;
        }
        .paging{
            float: right;
        }
        @media only screen and (min-width: 992px) and (max-width: 1199px){
            .operateBtn{
                padding: 8px 10px;
            }
        }
        @media only screen and (min-width: 768px) and (max-width: 992px){
            .operateBtn{
                padding: 7px;
            }
        }
        @media only screen and (max-width: 768px){
            .operateBtn{
                padding: 5px 3px;
            }
        }  
    }
    
</style>
<script>
import requestMixin from '../../mixins/request'
import common from '../../mixins/common'
import axios from '../../env/axios'
import apis from '../../env/apis'
export default {
    mixins : [requestMixin,common],
    data(){
        return {
            input5:'',
            tableData3: [],
            loading:false,
            formNamesVal2:null,
            shopList:''
        }
    },
    mounted(){
        this.$nextTick(function () {
            //执行
            this.loadingArea().then((res) => {
                this.shopList = res;
                this.getParams();
            });
            
        })
    },
    methods:{
         //下载表格
        downLoad2(name){
            this.isDownTable(this.tableData3, this.downLoad ,name);
        },
        /**
         * 格式化用户 U => 普通用户
         */
        userFormatter(row, column, cellValue, index){
            if(cellValue == 'U'){
               return '普通用户'
            }else if(cellValue == 'A'){
               return '管理员'
            }else{
                return ''
            }
        },
        //添加账户
        addAccount(){
            this.$router.push('addAccount')
        },
        //删除账户
        deleteRow(index, rows) {
            var that = this;
            let userId = rows.userId ;
            that.$confirm('此操作将永久删除,是否继续？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                axios.post(apis.baseURL, {
                    userId: userId,
                    act:'delUser'
                })
                .then(function (res) {
                    if(res.data.status == true){
                        that.$message({
                            type: 'success',
                            message: '删除成功 √ '
                        });
                        that.getParams();
                    }else{
                        if(res.data.msg){
                            that.$alert(res.data.msg, '提示', {
                                confirmButtonText: '确定',
                                type: 'warning',
                                center: true
                            });
                        }else{
                            that.$alert('删除失败!', '提示', {
                                confirmButtonText: '确定',
                                type: 'warning',
                                center: true
                            });
                        } 
                    }
                    
                })
                .catch(function (error) {
                    that.$message({
                        type: 'error',
                        message: '网络错误或请求异常 X '
                    });
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            }); 
        },

        /**
         * 加载账户列表信息
         */
        getParams(){
            //-1.加载账户信息
            this.loading = true;
            let userId = sessionStorage.getItem("userId") ;
            let userLevel = sessionStorage.getItem("userLevel") ;
            console.log(apis.baseURL)
            axios.post(apis.baseURL, {
                    act:"findUsers",
                    level:userLevel,
                    userId:''
                }).then((res) =>{
                    console.log(res)
                    this.loading = false;
                    if(res.data.status == true){
                        let result = res.data.list;
                        //主要操作店铺名与店铺code一一对应
                        if(this.shopList){
                            result.forEach((element, index, result) =>{
                                this.shopList.forEach((element2, index2, shopList) =>{
                                    if(element.locationCode == element2.locationCode){
                                        element.locationCode = element2.description
                                    }
                                })
                                
                            })
                        }
                        this.tableData3 = result;
                    } else{
                        this.promptMsg('加载失败','提示')
                    }       
                }).catch((error) =>{
                    console.log(error)
                    this.loading = false;
                    this.$message({
                        type: 'error',
                        message: '同步失败'
                    }); 
                })  
        },
        // async getUserLocation(){
        //     let result ;
        //     let userId = sessionStorage.getItem("userId") ;
        //     let userLevel = sessionStorage.getItem("userLevel") ;
        //     let params = {
        //         act : "findUsers",
        //         userId 
        //     }
        //     await axios.post(apis.baseURL, params)
        //         .then( (res) => {
        //             if(res.data.status == true){
        //                 this.loading = false;
        //                 result = res.data.list[0].locationCode;
        //             }else{
        //                 this.loading = false;
        //                 this.promptMsg('加载失败','提示')
        //             } 
        //         })
        //         .catch( (error) => {
        //             this.loading = false;
        //             this.$message({
        //                 showClose: true,
        //                 message: '请求不到数据或网络连接异常',
        //                 type: 'error'
        //             });
        //         })
        //         return result;
        // },



        /**
         * 加载店铺信息
        */
        async loadingArea(){
            this.loading = true;
            let userId = sessionStorage.getItem("userId") ;
            let shopList ;
            let params = {
                act:'findLocations',
                userId
            }
            await this.findType(params).then( (res) => {
                if(res.data.status == true){
                    //this.loading = false;
                    //console.log(res)
                    let result = res.data.list;
                    shopList = result;
                }
            })
            return shopList;
        },

        //修改账户->请求后台数据
        revise(index,rows){
            console.log(index)
            console.log(rows)
            let userId = rows.userId ;
            this.getUserIndex("findUsers",elem => elem.userId == userId).then((res) =>{
                console.log(res)
                this.$router.push({
                    path:'/system/delAccount',
                    query:{
                        index
                    }
                })  
            })
            // 跳转到添加账户界面，并且从后台重新请求数据
              
        },

        //刷新页面->请求后台列表数据
        refresh(){
            let that = this;
            that.getParams();   
        },

        //重置密码 ->
        resetPass(index,rows){
            //-1.跳转添加账户页面
            let userId = rows.userId ;
            this.getUserIndex("findUsers",elem => elem.userId == userId).then((res) =>{
                this.$router.push({
                    path:'/system/rePass',
                    query:{
                        index:res,
                        rePass:false
                    }
                })
            })
            
        }

    },
}
</script>
